import {ValidatorFn, Validators} from '@angular/forms';
import {IValidationRule, IValidationRuleExt} from '@core/api/data-access';
import {BE} from '@utils';

import {RegexGenerator} from '../logic';

import BESchema = BE.BESchema;
import BEProp = BE.BEProp;

@BESchema()
export class ValidationRuleModel implements IValidationRuleExt {
	@BEProp() key: string;
	@BEProp() name: string;
	@BEProp() isEnabled: boolean;
	@BEProp() isLocked: boolean;
	@BEProp() rule: string;
	@BEProp() description: string;
	@BEProp() errorMessage: string;
	@BEProp() successMessage: string;

	public validator: ValidatorFn = null;

	constructor(validationRule: IValidationRule) {
		Object.assign(this, validationRule);
		this._initValidators();
	}

	private _initValidators(): void {
		if (this.rule) {
			const regex = RegexGenerator(this.rule);
			if (!regex) return;
			this.validator = Validators.pattern(regex);
		}
	}
}
